'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _class2, _temp2, _class3, _temp3; /**
                                                      * Created by zfc on 2017/3/6.
                                                      */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftNavButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LeftNavButton, _Component);

  function LeftNavButton() {
    (0, _classCallCheck3.default)(this, LeftNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LeftNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(LeftNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./GoeasyCarouselTsqy.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.Carousel_side }));
    }
  }]);
  return LeftNavButton;
}(_react.Component), _class.propTypes = {}, _temp);
var RightNavButton = (_temp2 = _class2 = function (_Component2) {
  (0, _inherits3.default)(RightNavButton, _Component2);

  function RightNavButton() {
    (0, _classCallCheck3.default)(this, RightNavButton);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(RightNavButton).apply(this, arguments));
  }

  (0, _createClass3.default)(RightNavButton, [{
    key: 'render',
    value: function render() {
      var styles = require('./GoeasyCarouselTsqy.scss');
      return _react2.default.createElement('a', (0, _extends3.default)({}, this.props, { className: styles.Carousel_side + ' ' + styles.Carousel_side_right }));
    }
  }]);
  return RightNavButton;
}(_react.Component), _class2.propTypes = {
  page: _react.PropTypes.string
}, _temp2);
var GoeasyCarouselTsqy = (_temp3 = _class3 = function (_Component3) {
  (0, _inherits3.default)(GoeasyCarouselTsqy, _Component3);

  function GoeasyCarouselTsqy() {
    (0, _classCallCheck3.default)(this, GoeasyCarouselTsqy);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasyCarouselTsqy).apply(this, arguments));
  }

  (0, _createClass3.default)(GoeasyCarouselTsqy, [{
    key: 'onPageHref',
    value: function onPageHref(url) {
      window.location.href = url;
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./GoeasyCarouselTsqy.scss');
      var _props = this.props;
      var style = _props.style;
      var datas = _props.datas;
      var isArrow = _props.isArrow;

      var currentData = [];
      if (datas instanceof Array && datas.length > 0) {
        datas.forEach(function (singleData, index) {
          if (index % 8 === 0) {
            currentData.push({
              items: [(0, _extends3.default)({}, singleData)]
            });
          } else {
            currentData[Math.floor(index / 8)].items.push((0, _extends3.default)({}, singleData));
          }
        });
      }
      console.log(isArrow);
      var settings = {
        dots: false,
        infinite: true,
        arrows: isArrow,
        dotsClass: 'slick-dots ' + styles.dotsClass,
        // fade: true,
        autoplay: isArrow,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        prevArrow: isArrow ? _react2.default.createElement(LeftNavButton, this.props) : '',
        nextArrow: isArrow ? _react2.default.createElement(RightNavButton, this.props) : ''
      };
      return _react2.default.createElement(
        _reactSlick2.default,
        (0, _extends3.default)({ className: styles.carousel }, settings, { style: (0, _extends3.default)({}, style) }),
        currentData.map(function (singleObject, index) {
          return _react2.default.createElement(
            'ul',
            { key: 'ul' + index, className: styles.lie },
            singleObject.items instanceof Array ? singleObject.items.map(function (singleItem) {
              return _react2.default.createElement(
                'li',
                { key: singleItem.id },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: styles.imga,
                    to: singleItem.url,
                    target: '_blank' },
                  _react2.default.createElement('img', { src: singleItem.imgUrl,
                    alt: '' })
                )
              );
            }) : ''
          );
        })
      );
    }
  }]);
  return GoeasyCarouselTsqy;
}(_react.Component), _class3.propTypes = {
  style: _react.PropTypes.object,
  datas: _react.PropTypes.array,
  url: _react.PropTypes.string,
  page: _react.PropTypes.string,
  isArrow: _react.PropTypes.bool
}, _temp3);
exports.default = GoeasyCarouselTsqy;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyCarousel/GoeasyCarouselTsqy.js
 ** module id = 1339
 ** module chunks = 0
 **/